import _ from 'lodash';
import {
  DELIVERY_HOUR_ROUTE,
  HUBRISE_ROUTE,
  PRINTER_ROUTE,
  DEFAULT_RADIUS,
  SPECIFIC_HOUR_ROUTE,
  OPENED_HOUR_ROUTE,
  GENERAL_CONFIG_ROUTE,
  DELIVERY_ZONE_ROUTE,
  MANAGEMENT_FEE_ROUTE,
  DELIVERY_SETTINGS_ROUTE,
  GENERAL_DESIGN_ROUTE,
  WEB_DESIGN_ROUTE,
  MOBILE_DESIGN_ROUTE,
  CODE_PROMO_ROUTE,
  PUSH_NOTIF_ROUTE,
  FEDILITY_PROGRAM_ROUTE,
  ACTIVATION_ROUTE,
  DEEPLINK_ROUTE,
  SIDEBAR_ROUTES
} from '../constants';
import { checkAccess } from './admins';
import store from './store';

import { generateToken } from 'topkat-utils'
import moment from 'moment';
export const isIntegerNotNull = integer => parseInt(integer, 10) !== 0 && integer;

export const removeEmpty = obj => { // TODO naming should be removeUndefinedFromObjectRecursive
  const newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] === Object(obj[key])) newObj[key] = removeEmpty(obj[key]);
    else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
};

export const removeEmptyStringsFromObject = obj => {
  _.map(obj, (o, key) => {
    if (!isStringNotNull(o)) {
      delete obj[key];
    }
  });
  return obj;
};

export const displayPriceFormat = price => {
  return `${String(Number(price).toFixed(2)).replace('.', ',')} €`;
};
export const displayVariableValue = value => {
  if (value === null || value === undefined) return '0,00';

  const numericValue =
    typeof value === 'string'
      ? parseFloat(value.replace(',', '.'))
      : Number(value);

  if (isNaN(numericValue)) return '0,00';

  return numericValue.toFixed(2).replace('.', ',');
};


export const isStringNotNull = string => {
  return string && !/^\s*$/.test(string) // check only whitespace or linebreaks
};

export const isObjectNotEmpty = object => {
  return object && !_.isEmpty(object);
}

export const getFirebasePath = key => {
  return key
    .replace(/\s+/g, '_')
    .replace(/\//g, '_')
    .replace(/[.#$[\],]/g, '')
}

export const removeEmptyStringFromObjectValues = dirtyData => {
  const data = { ...dirtyData }
  _.map(dirtyData, (value, key) => {
    if (typeof value === 'string' && value === '') delete data[key]
  })
  return data;
}

export const isEmail = mail => {
  const reg = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return reg.test(String(mail).toLowerCase());
};

export const checkSideBarAccess = (url) => {
  const { user, firebaseRealTime } = store.getState();
  const { oneTouchEnabled, isAllShops, configLegal } = user;
  const { generalConfig } = firebaseRealTime;
  const {
    webapp = {},
    terminal = {},
    qrcode = {},
    mobileApp = {},
    url: urlConfig,
    dashboard = {}
  } = generalConfig;
  const { url: oldUrl } = webapp;

  const isWebApp =
    (urlConfig || oldUrl) &&
    (webapp.enabled || terminal.enabled || qrcode.enabled);

  const isMobileApp = mobileApp.enabled;
  const hasNotAccess =
    (oneTouchEnabled &&
      (url === '/products' || url === '/options-products')) ||
    ((!checkAccess('pages', 'designWeb') || !isWebApp) && url === '/design') ||
    (!isMobileApp && url === '/support') ||
    (isAllShops &&
      (['/code-promo', '/livreurs', '/products', '/options-products', '/support', '/sales'].includes(url) ||
        (url === '/invoice' && !configLegal)
      )) ||
    (!checkAccess('pages', 'finance') && url === '/finances') ||
    (!checkAccess('pages', 'marketing') && url === '/marketing') ||
    (url === SIDEBAR_ROUTES.CLIENTS && dashboard?.customersTabVisibility?.hideTab);

  return hasNotAccess;
};

export const checkSettingAccess = (url) => {
  const { user, firebaseRealTime } = store.getState();
  const { dashboardConfig, isAllShops, nbShops } = user;
  const { printer } = dashboardConfig;
  const { shop = {}, generalConfig } = firebaseRealTime;
  const { configuration = {} } = shop;
  const { orderTypes, externalIntegration = {} } = configuration;
  const { configuration: externalIntagrationConfiguration = {} } = externalIntegration;
  const { show = false } = externalIntagrationConfiguration;
  const { webapp = {}, chatbot = {}, mobileApp = {} } = generalConfig;
  const deliveryTech = mobileApp.enabled || webapp.enabled || chatbot.enabled;
  const deliverySlots = orderTypes && orderTypes.includes('delivery') && deliveryTech;
  const hasNotAccess =
    (!deliverySlots && url === DELIVERY_HOUR_ROUTE) ||
    (!show && url === HUBRISE_ROUTE) ||
    ((printer || (printer && printer.type !== 'QZ')) && url === PRINTER_ROUTE) ||
    (!isAllShops && nbShops > 1 && url === MANAGEMENT_FEE_ROUTE) ||
    (isAllShops &&
      (url === SPECIFIC_HOUR_ROUTE ||
        url === DELIVERY_HOUR_ROUTE ||
        url === OPENED_HOUR_ROUTE ||
        url === PRINTER_ROUTE ||
        url === HUBRISE_ROUTE ||
        url === GENERAL_CONFIG_ROUTE ||
        url === DELIVERY_ZONE_ROUTE)) ||
    (url === DELIVERY_SETTINGS_ROUTE && !checkAccess('features', 'deliverySettings'));
  return hasNotAccess;
};
export const checkMarketingAccess = (url) => {
  const { user, firebaseRealTime } = store.getState();
  const { isAllShops, nbShops, oneTouchEnabled } = user;
  const { generalConfig = {} } = firebaseRealTime;
  const isMobileApp = generalConfig?.mobileApp.enabled;
  const hasNotAccess =
    (!isMobileApp && url === PUSH_NOTIF_ROUTE) || (oneTouchEnabled && url === CODE_PROMO_ROUTE) ||
    (!isAllShops &&
      nbShops > 1 &&
      (url === GENERAL_DESIGN_ROUTE ||
        url === WEB_DESIGN_ROUTE ||
        url === MOBILE_DESIGN_ROUTE ||
        url === FEDILITY_PROGRAM_ROUTE || url === ACTIVATION_ROUTE || url === DEEPLINK_ROUTE));

  return hasNotAccess;
};

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let randomColor = '#';
  for (let i = 0; i < 6; i++) {
    randomColor += letters[Math.floor(Math.random() * 16)];
  }
  return randomColor;
};
export const getDefaultSquareBounding = (platitude, plongitude) => {
  const latRadian = (platitude * Math.PI) / 180;

  const degLatKm = 110.574235;
  const degLongKm = 110.572833 * Math.cos(latRadian);
  const deltaLat = DEFAULT_RADIUS / 1000.0 / degLatKm;
  const deltaLong = DEFAULT_RADIUS / 1000.0 / degLongKm;

  const topLat = platitude + deltaLat;
  const bottomLat = platitude - deltaLat;
  const leftLng = plongitude - deltaLong;
  const rightLng = plongitude + deltaLong;

  const northWestCoords = { latitude: topLat, longitude: leftLng };
  const northEastCoords = { latitude: topLat, longitude: rightLng };
  const southWestCoords = { latitude: bottomLat, longitude: leftLng };
  const southEastCoords = { latitude: bottomLat, longitude: rightLng };

  const boundingBox = [northWestCoords, southWestCoords, southEastCoords, northEastCoords];
  return boundingBox;
};

export const keyGenerator = type => `${type}_${generateToken(12)}`

export const displayPhoneNumberFormat = number => {
  let replaced = number.replace(/\s/g, '');
  if (number.startsWith('0')) {
    replaced = replaced.replace('0', '+33');
  }
  return replaced;
};
export const isFloatNotNull = value => {
  const floatValue = parseFloat(value);
  return !isNaN(floatValue) && floatValue !== null && floatValue !== 0;
};

export const isValidFrenchDecimalInput = rawValue => {
  if (rawValue === '') return true;
  return /^\d*(,\d{0,2})?$/.test(rawValue);
};

export const formattedValue = (value) => {
  return Number.isInteger(value) ? value : value.toFixed(2)
}
export const combineDateAndTime = (date, time) => {
  const [hours, minutes] = time.split(':');
  return moment(date)
    .set({ hour: parseInt(hours, 10), minute: parseInt(minutes, 10), second: 0 })
    .toISOString();
};

export const removeUndefinedProperties = (obj) => {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object') {
        removeUndefinedProperties(obj[key]);
      } else if (obj[key] === undefined || obj[key] === null) {
        delete obj[key];
      }
    });
  }
  return obj;
};
export const formatDateTime = (dateString) => {
  if (!dateString) return 'Non spécifié';
  return moment(dateString).format('DD/MM/YYYY [à] HH:mm');
};
export const hasMultipleItems = (array) => {
  return Array.isArray(array) && array.length > 1;
};